var analytics_default = ({ $config }) => {
  const { googleGtagId, fbAnalyticsId, twAnalyticsId } = $config;
  if (googleGtagId) {
    let gtag2 = function() {
      dataLayer.push(arguments);
    };
    var gtag = gtag2;
    window.dataLayer = window.dataLayer || [];
    gtag2("js", /* @__PURE__ */ new Date());
    gtag2("config", googleGtagId);
  }
  if (fbAnalyticsId) {
    !function(f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );
    fbq("init", fbAnalyticsId);
    fbq("track", "PageView");
  }
  if (twAnalyticsId) {
    !function(e, t, n, s, u, a) {
      e.twq || (s = e.twq = function() {
        s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
      }, s.version = "1.1", s.queue = [], u = t.createElement(n), u.async = true, u.src = "https://static.ads-twitter.com/uwt.js", a = t.getElementsByTagName(n)[0], a.parentNode.insertBefore(u, a));
    }(window, document, "script");
    twq("config", twAnalyticsId);
  }
};
export {
  analytics_default as default
};
